var exports = {
  "k": "xa15a2ab7--4c2158--container",
  "J": "xa15a2ab7--4c2158--svg",
};

module.exports = exports;
